// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"29aefb4e","668":"3a87315d","681":"d368621c","730":"e6b8f21e","760":"d3b2a878","874":"80c6828b"}[chunkId] + ".chunk.js";
};